import React, { useState } from 'react';

export interface MarkerProps {
  testId: string;
}

/**
 * Component meant to make it easier to know when another component is fully loaded.
 * Expected test id format: marker-{id}.
 *
 * data-testid is used to check that the marker exists (use: span[data-type="marker"][data-testid="..."])
 * data-last-render is meant to be used to check for rendering where not expected
 * data-last-mount is meant to be used to check for view refreshes and full unmount/mount
 */
export const Marker: React.FC<MarkerProps> = props => {
  const { testId } = props;
  const [mountTime] = useState(Date.now());
  return (
    <span
      aria-hidden="true"
      data-type="marker"
      data-testid={testId}
      data-last-render={Date.now()}
      data-last-mount={mountTime}
    ></span>
  );
};
